import { Button, EmptyState } from "@lumberset/ui";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Outlet,
  notFoundComponent: () => (
    <div className="flex min-h-dvh items-center justify-center">
      <EmptyState
        title="Nothing here"
        description="That page does not exist, or you no longer have access to it."
        action={
          <Button asChild variant="secondary">
            <Link to="/">Back to LumberSet</Link>
          </Button>
        }
      />
    </div>
  ),
});
